import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const routes = [
  {
    path: '/',
    name: 'Login',
    // redirect: "/login",
    component: () => import('../views/index.vue'),
  },
  {
    path: '/register',
    component: () => import('../views/user/Register.vue'),
  },
  {
    path: '/home',
    // name: 'Home',
    // redirect: JSON.parse(localStorage.getItem('isWorker'))== true ? "/fell/fellAreaManage" : "infoManage/fellAreaManage",
    component: () => import('../views/home.vue'),
    children: [
      {
        path: '/',
        component: () => import('../views/dataScreen/index.vue'),
      },
      {
        path: '/mainIndex',
        name: 'mainIndex',
        meta: {
          label: '首页',
        },
        component: () => import('../views/index/index.vue'),
        children: [],
      },
      {
        path: '/fell',
        name: 'fell',
        meta: {
          label: '林木管理',
        },
        component: () => import('../views/fellAreaManage/index.vue'),
        children: [
          {
            path: '/fell/fellAreaManage',
            name: 'fellAreaManage',
            meta: {
              label: '伐区列表',
              id: 1,
            },
            component: () => import('../views/fellAreaManage/fellAreaManage2.vue'),
          },
          {
            path: '/fell/fellAreaSale',
            name: 'fellAreaSale',
            meta: {
              label: '林木销售',
              id: 1,
            },
            component: () => import('../views/fellAreaManage/fellAreaSale.vue'),
          },
          {
            path: '/fell/incomingAccount',
            name: 'incomingAccount',
            meta: {
              label: '经营入库台账',
              id: 1,
            },
            component: () => import('../views/operateManage/incomingAccount.vue'),
          },
          {
            path: '/fell/outboundAccount',
            name: 'outboundAccount',
            meta: {
              label: '经营出库台账',
              id: 1,
            },
            component: () => import('../views/operateManage/outboundAccount.vue'),
          },
        ],
      },
      {
        path: '/forestManage',
        name: 'forestManage',
        meta: {
          label: '林长任务',
        },
        component: () => import('../views/forestManage/index.vue'),
        children: [
          {
            path: '/forestManage/person',
            name: 'personManage',
            meta: {
              label: '人员管理',
              id: 8,
            },
            component: () => import('../views/forestManage/personManage.vue'),
          },
          {
            path: '/forestManage/foresterCount',
            name: 'foresterCount',
            meta: {
              label: '林长统计',
              id: 8,
            },
            component: () => import('../views/forestManage/foresterCount.vue'),
          },
          {
            path: '/forestManage/missionPlatform',
            name: 'missionPlatform',
            meta: {
              label: '任务平台',
              id: 8,
            },
            component: () => import('../views/forestManage/missionPlatform.vue'),
          },
          {
            path: '/forestManage/foresterPatrol',
            name: 'foresterPatrol',
            meta: {
              label: '林长巡护',
              id: 8,
            },
            component: () => import('../views/forestManage/foresterPatrol.vue'),
          },
        ],
      },
      {
        path: '/vectorTaskManage',
        name: 'vectorTaskManage',
        meta: {
          label: '核查任务',
        },
        component: () => import('../views/vectorTaskManage/index.vue'),
        children: [
          {
            path: '/vectorTaskManage/vectorTaskCount',
            name: 'vectorTaskCount',
            meta: {
              label: '核查统计',
              id: 9,
            },
            component: () => import('../views/vectorTaskManage/vectorTaskCount.vue'),
          },
          {
            path: '/vectorTaskManage/vectorTaskUserManage',
            name: 'vectorTaskUserManage',
            meta: {
              label: '人员管理',
              id: 9,
            },
            component: () => import('../views/vectorTaskManage/vectorTaskUserManage.vue'),
          },
          {
            path: '/vectorTaskManage/vectorTaskPlatform',
            name: 'vectorTaskPlatform',
            meta: {
              label: '任务平台',
              id: 9,
            },
            component: () => import('../views/vectorTaskManage/vectorTaskPlatform.vue'),
          },
        ],
      },
      {
        path: '/approveManage',
        name: 'approveManage',
        meta: {
          label: '审批管理',
        },
        component: () => import('../views/approveManage/index.vue'),
        children: [
          {
            path: '/approveManage/fellLicenceApprove',
            name: 'fellLicenceApprove',
            meta: {
              label: '采伐证审批',
              id: 3,
            },
            component: () => import('../views/approveManage/fellLicenceApprove.vue'),
          },
          {
            path: '/approveManage/approveCount',
            name: 'approveCount',
            meta: {
              label: '审批统计',
              id: 3,
            },
            component: () => import('../views/approveManage/approveCount.vue'),
          },
          {
            path: '/approveManage/useFireApprove',
            name: 'useFireApprove',
            meta: {
              label: '用火审批',
              id: 3,
            },
            component: () => import('../views/approveManage/useFireApprove.vue'),
          },
          {
            path: '/approveManage/fellLicenceApply',
            name: 'fellLicenceApply',
            meta: {
              label: '预约管理',
              id: 3,
            },
            component: () => import('../views/approveManage/fellLicenceApply.vue'),
          },
          {
            path: '/approveManage/fellerApprove',
            name: 'fellerApprove',
            meta: {
              label: '采伐者审核',
              id: 3,
            },
            component: () => import('../views/approveManage/fellerApprove.vue'),
          },
          {
            path: '/approveManage/factoryApprove',
            name: 'factoryApprove',
            meta: {
              label: '集材厂/加工厂资质审核',
              id: 3,
            },
            component: () => import('../views/approveManage/factoryApprove.vue'),
          },
        ],
      },
      {
        path: '/messageManage',
        name: 'messageManage',
        meta: {
          label: '信息管理',
        },
        component: () => import('../views/messageManage/index.vue'),
        children: [
          {
            path: '/messageManage/operator',
            name: 'operator',
            meta: {
              label: '采伐者',
              id: 4,
            },
            component: () => import('../views/fellAreaManage/operator.vue'),
          },
          {
            path: '/messageManage/facs',
            name: 'facs',
            meta: {
              label: '集材厂/加工厂',
              id: 4,
            },
            component: () => import('../views/operateManage/facs.vue'),
          },
          {
            path: '/messageManage/eventManage',
            name: 'eventManage',
            meta: {
              label: '事件管理',
              id: 7,
            },
            component: () => import('../views/messageManage/eventManage.vue'),
          },
          {
            path: '/messageManage/punishRecord',
            name: 'punishRecord',
            meta: {
              label: '处罚记录',
              id: 7,
            },
            component: () => import('../views/messageManage/punishRecord.vue'),
          },
          {
            path: '/messageManage/patrol',
            name: 'patrol',
            meta: {
              label: '打卡管理',
              id: 7,
            },
            component: () => import('../views/messageManage/patrol.vue'),
          },
          {
            path: '/messageManage/reportManage',
            name: 'reportManage',
            meta: {
              label: '上报管理',
              id: 4,
            },
            component: () => import('../views/messageManage/reportManage.vue'),
          },
          {
            path: '/messageManage/noticeManage',
            name: 'noticeManage',
            meta: {
              label: '公告管理',
              id: 4,
            },
            component: () => import('../views/messageManage/noticeManage.vue'),
          },
          {
            path: '/messageManage/punish',
            name: 'punish',
            meta: {
              label: '行政通知',
              id: 4,
            },
            component: () => import('../views/messageManage/punish.vue'),
          },
          {
            path: '/messageManage/defaultText',
            name: 'punish',
            meta: {
              label: '审批预设',
              id: 4,
            },
            component: () => import('../views/messageManage/defaultText.vue'),
          },
        ],
      },
      {
        path: '/coverageManage',
        name: 'coverageManage',
        meta: {
          label: '数据共享',
        },
        component: () => import('../views/coverageManage/index.vue'),
        children: [
          // {
          // 	path: "/coverageManage/shareCoverage",
          // 	name: "shareCoverage",
          // 	meta: {
          // 		label: "共享图层",
          // 		id:5
          // 	},
          // 	component: () =>
          // 		import("../views/coverageManage/shareCoverage.vue")
          // },
          {
            path: '/coverageManage/oneMap',
            name: 'oneMap',
            meta: {
              label: '一张图',
              id: 5,
            },
            component: () => import('../views/coverageManage/oneMap.vue'),
          },
          {
            path: '/coverageManage/dataManage',
            name: 'dataManage',
            meta: {
              label: '数据管理',
              id: 5,
            },
            component: () => import('../views/coverageManage/dataManage.vue'),
          },
          {
            path: '/coverageManage/eMap',
            name: 'eMap',
            meta: {
              label: '电子地图',
              id: 5,
            },
            component: () => import('../views/coverageManage/eMap.vue'),
          },
          {
            path: '/coverageManage/dataDownload',
            name: 'dataDownload',
            meta: {
              label: '数据下载',
              id: 5,
            },
            component: () => import('../views/coverageManage/dataDownload.vue'),
          },
          {
            path: '/coverageManage/ShareGroup',
            name: 'ShareGroup',
            meta: {
              label: '组别管理',
              id: 5,
            },
            component: () => import('../views/coverageManage/ShareGroup.vue'),
          },
        ],
      },
      {
        path: '/userManage',
        name: 'userManage',
        meta: {
          label: '平台管理',
        },
        component: () => import('../views/userManage/index.vue'),
        children: [
          {
            path: '/userManage/ordinaryUser',
            name: 'ordinaryUser',
            meta: {
              label: '用户管理',
              id: 6,
            },
            component: () => import('../views/userManage/ordinaryUser.vue'),
          },
          {
            path: '/userManage/worker',
            name: 'worker',
            meta: {
              label: '工作人员',
              id: 6,
            },
            component: () => import('../views/userManage/worker.vue'),
          },
          {
            path: '/userManage/role',
            name: 'role',
            meta: {
              label: '角色管理',
              id: 6,
            },
            component: () => import('../views/userManage/role.vue'),
          },
          {
            path: '/userManage/areaManage',
            name: 'area',
            meta: {
              label: '区域管理',
              id: 6,
            },
            component: () => import('../views/userManage/areaManage.vue'),
          },
          {
            path: '/userManage/process',
            name: 'process',
            meta: {
              label: '流程设计',
              id: 6,
            },
            component: () => import('../views/userManage/process.vue'),
          },
          {
            path: '/userManage/coverageManage',
            name: 'coverage',
            meta: {
              label: '图层管理',
              id: 6,
            },
            component: () => import('../views/userManage/coverageManage.vue'),
          },
          {
            path: '/userManage/map',
            name: 'map',
            meta: {
              label: '共享管理',
              id: 5,
            },
            component: () => import('../views/userManage/map.vue'),
          },
          {
            path: '/userManage/app',
            name: 'app',
            meta: {
              label: 'APP版本管理',
              id: 6,
            },
            component: () => import('../views/userManage/app.vue'),
          },
          {
            path: '/userManage/logManage',
            name: 'logManage',
            meta: {
              label: '日志管理',
              id: 6,
            },
            component: () => import('../views/userManage/logManage.vue'),
          },
          {
            path: '/userManage/pushManage',
            name: 'pushManage',
            meta: {
              label: '推送管理',
              id: 6,
            },
            component: () => import('../views/userManage/pushManage.vue'),
          },
        ],
      },
      {
        path: '/userCenter',
        name: 'userCenter',
        meta: {
          label: '个人中心',
        },
        component: () => import('../views/userCenter/index.vue'),
        children: [],
      },
      // 普通用户相关路由
      {
        path: '/infoManage',
        name: 'infoManage',
        meta: {
          label: '信息管理',
        },
        component: () => import('../views/infoManage/index.vue'),
        children: [
          {
            path: '/infoManage/fellAreaManage',
            name: 'fellAreaManage2',
            meta: {
              label: '伐区管理',
              id: 1,
            },
            component: () => import('../views/infoManage/fellAreaManage.vue'),
          },
          {
            path: '/infoManage/reserveManage',
            name: 'reserveManage',
            meta: {
              label: '我的预约',
              id: 1,
            },
            component: () => import('../views/infoManage/reserveManage.vue'),
          },
          {
            path: '/infoManage/designManage',
            name: 'designManage',
            meta: {
              label: '设计管理',
              id: 1,
            },
            component: () => import('../views/infoManage/designManage.vue'),
          },
          {
            path: '/infoManage/incomingManage',
            name: 'incomingManage',
            meta: {
              label: '入库管理',
              id: 1,
            },
            component: () => import('../views/infoManage/incomingManage.vue'),
          },
          {
            path: '/infoManage/outingManage',
            name: 'outingManage',
            meta: {
              label: '出库管理',
              id: 1,
            },
            component: () => import('../views/infoManage/outingManage.vue'),
          },
          {
            path: '/infoManage/fellAreaSaleManage',
            name: 'fellAreaSaleManage',
            meta: {
              label: '林木销售管理',
              id: 1,
            },
            component: () => import('../views/infoManage/fellAreaSaleManage.vue'),
          },
          {
            path: '/infoManage/approveManage',
            name: 'approveManage2',
            meta: {
              label: '我的审批',
              id: 1,
            },
            component: () => import('../views/infoManage/approveManage.vue'),
          },
          {
            path: '/userCenter2/feller',
            name: 'feller',
            meta: {
              label: '采伐者',
              id: 1,
            },
            component: () => import('../views/userCenter2/feller.vue'),
          },
          {
            path: '/userCenter2/factories',
            name: 'factories',
            meta: {
              label: '加工厂/集材厂',
              id: 1,
            },
            component: () => import('../views/userCenter2/factories.vue'),
          },
          {
            path: '/userCenter2/noticeManage',
            name: 'noticeManage',
            meta: {
              label: '公告管理',
              id: 1,
            },
            component: () => import('../views/userCenter2/noticeManage.vue'),
          },
        ],
      },
      {
        path: '/userCenter2',
        name: 'userCenter2',
        meta: {
          label: '用户中心',
        },
        component: () => import('../views/userCenter2/index.vue'),
        children: [
          {
            path: '/userCenter2/feller',
            name: 'feller',
            meta: {
              label: '采伐者',
              id: 2,
            },
            component: () => import('../views/userCenter2/feller.vue'),
          },
          {
            path: '/userCenter2/factories',
            name: 'factories',
            meta: {
              label: '加工厂/集材厂',
              id: 2,
            },
            component: () => import('../views/userCenter2/factories.vue'),
          },
        ],
      },
      {
        path: '/patrolManagement',
        name: 'patrolManagement',
        meta: {
          label: '巡护管理',
        },
        component: () => import('../views/patrolManagement/index.vue'),
        children: [
          {
            path: '/patrolManagement/peopleManagement',
            name: 'peopleManagement',
            meta: {
              label: '人员管理',
              id: 7,
            },
            component: () => import('../views/patrolManagement/peopleManagement.vue'),
          },
          {
            path: '/patrolManagement/iawEnforcingManagement',
            name: 'iawEnforcingManagement',
            meta: {
              label: '执法管理',
              id: 7,
            },
            component: () => import('../views/patrolManagement/iawEnforcingManagement.vue'),
          },
          {
            path: '/patrolManagement/patrolCount',
            name: 'patrolCount',
            meta: {
              label: '巡护统计',
              id: 7,
            },
            component: () => import('../views/patrolManagement/patrolCount.vue'),
          },
        ],
      },
      // 设计公司路由
      {
        path: '/SJGS/myReserve',
        name: 'myReserve',
        meta: {
          label: '我的预约',
          id: 41,
        },
        component: () => import('../views/SJGS/myReserve.vue'),
        children: [],
      },
      {
        path: '/SJGS/oneMap',
        name: 'oneMap',
        meta: {
          label: '一张图',
          id: 42,
        },
        component: () => import('../views/SJGS/oneMap.vue'),
        children: [],
      },
    ],
  },
  // {
  // 	path: '/dataScreen',
  // 	component: () => import('../views/dataScreen/index.vue')
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  store.commit('setActivateMenu', to.meta.id)
  store.commit('setActivateMenuUrl', to.path)
  if (to.meta.label) {
    let value = {
      name: to.meta.label,
      url: to.path,
    }
    store.commit('mutationSelectTags', value)
  }
  next()
})

export default router
